import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Ticket, Music2 } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

const LOGO = "/logo_fluo.png";

export default function Header() {
  const { count } = useCart();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) return null;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-black/60 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img src={LOGO} alt="FLUO Neuchâtel" className="h-12 w-auto" />
          <span
            className="hidden md:block font-display text-lg tracking-wider bg-clip-text text-transparent"
            style={{
              backgroundImage:
                "linear-gradient(45deg, #4EC5FF 0%, #8DE2FF 25%, #A5E6FF 42%, #FFF0CE 55%, #E4C58F 78%, #B8945C 100%)",
              filter: "drop-shadow(0 1px 0 rgba(0,0,0,0.5))",
            }}
          >
            SHOP OFFICIEL
          </span>
        </Link>

        <nav className="flex items-center gap-2 md:gap-3">
          <Link
            to="/"
            className="hidden lg:block uppercase text-xs tracking-widest hover:text-magenta transition-colors px-2"
            data-testid="nav-shop"
          >
            Boutique
          </Link>
          <a
            href="https://www.fluoneuchatel.com/line-up"
            target="_blank"
            rel="noreferrer"
            className="btn-ghost hidden sm:inline-flex"
            data-testid="nav-lineup"
          >
            <Music2 size={16} />
            <span className="hidden md:inline">Line-up</span>
          </a>
          <a
            href="https://www.fluoneuchatel.com/billetterie"
            target="_blank"
            rel="noreferrer"
            className="btn-ghost"
            data-testid="nav-billetterie"
          >
            <Ticket size={16} />
            <span className="hidden md:inline">Billetterie</span>
          </a>
          <Link
            to="/cart"
            className="relative p-2 hover:text-magenta transition-colors"
            data-testid="nav-cart"
          >
            <ShoppingBag size={22} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-1 -right-1 bg-magenta text-black text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </Link>
        </nav>
      </div>
    </header>
  );
}
